import {CommonModule} from '@angular/common';
import {Component, Inject, Input} from '@angular/core';
import {FormBuilder, FormControl, ReactiveFormsModule} from '@angular/forms';
import {EmMarkdownPipe, TranslationService, validators} from '@emma-labs/shared/angular';
import {ENVIRONMENT, EnvironmentBroker} from '@emma-labs/shared/typescript';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {DividerModule} from 'primeng/divider';
import {EditorModule} from 'primeng/editor';
import {InputTextareaModule} from 'primeng/inputtextarea';
import Quill from 'quill';
import Delta from 'quill-delta';
import {EnrichedProfileNote} from '../../../entities/underwriting-page-object/underwriting-page-object';
import {TurndownService} from '../../../services/turndown.service';
import {BaseSectionComponent} from '../../base-section/base-section.component';
import {getDateFormat} from '../utils';

@Component({
  selector: 'em-notes-section',
  templateUrl: './notes-section.component.html',
  imports: [
    CommonModule,
    CardModule,
    DividerModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextareaModule,
    EmMarkdownPipe,
    DialogModule,
    EditorModule,
  ],
})
export class NotesSectionComponent extends BaseSectionComponent<
  FormControl<string | null>,
  EnrichedProfileNote[],
  string
> {
  @Input({required: true})
  override set props(notes: EnrichedProfileNote[]) {
    const newNotes = notes
      .filter((note) => !this._notes.some((n) => n.id === note.id))
      .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

    this._notes.push(...newNotes);
  }

  _notes: EnrichedProfileNote[] = [];
  dateFormat: string;
  isLoading = false;
  isDialogVisible = false;

  constructor(
    readonly fb: FormBuilder,
    @Inject(ENVIRONMENT) environment: EnvironmentBroker,
    private readonly translate: TranslationService,
    private readonly turndownService: TurndownService,
  ) {
    super(environment);

    this.form = fb.control<string | null>(null, [validators.notEmpty]);
    this.dateFormat = getDateFormat(this.translate.getCurrentLanguageCode());
  }

  submitNote(): void {
    if (this.form.value) {
      this.isLoading = true;

      this.propsChange.emit({
        output: this.turndownService.turndown(this.form.value).replace(/\u00A0/g, ' '),
        callback: (status) => {
          if (status) {
            this.form.reset();
          }
          this.isLoading = false;
        },
      });
    }
  }

  openDialog(): void {
    this.isDialogVisible = true;
    this.form.reset();
  }

  onEditorInit(event: any) {
    const quill: Quill = event.editor;

    // Disable Quill's default behaviour of pasting with styles
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, _) => {
      const text = node.textContent;
      return new Delta().insert(text ?? '');
    });
  }
}
